import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, UserRound } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-mist border-y border-slate-200" data-id="element-284" data-mp="3nzv73wfw6dig">
      <div className="max-w-7xl mx-auto px-4" data-id="element-285" data-mp="3nxigyvzzcwub">
        <div className="text-center mb-7" data-id="element-286" data-mp="5kt2h5ddmhmy">
          <h2 className="text-navy font-bold tracking-widest uppercase text-sm" data-id="element-287" data-mp="5jrg44qwu8px">
            What Scuba Instructors Are Saying
          </h2>
          {hasSamples && <p className="text-xs text-slate-500 mt-2" data-id="element-288" data-mp="fiql9dcgvm86">
              Placeholder comments shown for layout — replace with verified customer feedback.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-289" data-mp="2hc6fek7rjj7w">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-navy/5 flex flex-col" data-id="element-290" data-mp="2cddavhagf2jv" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-291" data-mp="q5f59zgamcbz">
                <div className="flex gap-1 text-cta" aria-label="5 out of 5 stars" data-id="element-292" data-mp="v2fbcad57f33">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-293" data-mp="143vmikbs7l8d" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-[10px] font-bold uppercase tracking-wider text-ocean bg-mist px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-294" data-mp="192gbtophwki1">
                    Placeholder
                  </span>}
              </div>
              <p className="text-ink italic mb-6 text-sm leading-relaxed" data-id="element-295" data-mp="hzuvsvrvg00x">“{testimonial.text}”</p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-200" data-id="element-296" data-mp="d0rot5sbzjqb">
                <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center text-aqua shrink-0" aria-hidden="true" data-id="element-297" data-mp="d34d00oomqbt">
                  <UserRound size={18} data-id="element-298" data-mp="m3kej4lv7ne1" />
                </div>
                <div className="min-w-0" data-id="element-299" data-mp="10xfka1qq4wl0">
                  <div className="font-bold text-navy text-sm" data-id="element-300" data-mp="10wdxj00cilng">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-301" data-mp="vxjepy2dox3c">
                    <MapPin size={11} className="text-ocean shrink-0" data-id="element-302" data-mp="19qir3r6v6b6o" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}